import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IconCheckMarkHeader from '../../globals/images/icon-checkmark-header.svg'
import ReactDOM from 'react-dom'
import UrlBuilder from '../shared/urlBuilder/UrlBuilder'

export default class Confirmation extends Component  {
    componentDidMount() {
        ReactDOM.findDOMNode( this.refs.confirmationCard ).focus() 
    }

    get forgotPasswordUrl() {
        return process.env.REACT_APP_FORGOT_PASSWORD
    }
    
    render() {
        const { email } = this.props
        const title = 'Request Submitted'
        const message =`We'll email you a reset link if there is an account associated with ${ email }.`
        const sendAgainMessage = 'Did not receive the email?'
        const SendAgainMessageLink = 'Send again'
        const ariaMessage = `${ title }.${ message }.${ sendAgainMessage }.${ SendAgainMessageLink }`
        return (
            <>
                <main className="c-main forgot-password">
                    <div className="os-container--max-width">
                        <div className="c-form-card" ref={ 'confirmationCard' } aria-label={ ariaMessage } tabIndex={ 0 }>
                            <div className="c-form-card__container">
                                <h1 className="o-heading-alpha mb-8 pb-0 pl-9" tabIndex={ 0 }>
                                    <img src={ IconCheckMarkHeader } alt="Confirmation" className="c-svg-header-icon"/>
                                    { title }
                                </h1>
                                <div className="c-form-confirmation-message">
                                    <p tabIndex="0">{ message }</p>
                                    <div className="resend-email-box">
                                        <span tabIndex="0" className="send-email-msg">{ sendAgainMessage }</span>
                                        <a href={ UrlBuilder( { url: this.forgotPasswordUrl, buildURL: true } ) } id="resend-email" className="send-email-link">{ SendAgainMessageLink }</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </>
        )
    }
}

Confirmation.propTypes = {
    email: PropTypes.string.isRequired
}